var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluePhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.438,
    height: 29.435,
    viewBox: "0 0 29.438 29.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4353",
    "data-name": "Group 4353",
    transform: "translate(-211 -1374.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-call",
    "data-name": "Icon ionic-ios-call",
    d: "M33.077,27.551a24.725,24.725,0,0,0-5.165-3.456c-1.548-.743-2.115-.728-3.211.061-.912.659-1.5,1.272-2.552,1.042S19.03,23.405,17.023,21.4s-3.571-4.077-3.793-5.127.391-1.64,1.042-2.552c.789-1.1.812-1.663.061-3.211A24.237,24.237,0,0,0,10.877,5.35c-1.127-1.127-1.379-.881-2-.659a11.382,11.382,0,0,0-1.832.973,5.525,5.525,0,0,0-2.2,2.322c-.437.943-.943,2.7,1.632,7.28a40.622,40.622,0,0,0,7.142,9.525h0l.008.008.008.008h0a40.781,40.781,0,0,0,9.525,7.142c4.583,2.575,6.338,2.069,7.28,1.632a5.431,5.431,0,0,0,2.322-2.2,11.381,11.381,0,0,0,.973-1.832C33.959,28.93,34.211,28.677,33.077,27.551Z",
    transform: "translate(206.51 1369.498)",
    fill: "#527991"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePhone);
export default __webpack_public_path__ + "static/media/bluePhone.f9ec1f42.svg";
export { ForwardRef as ReactComponent };